export default {"src":"/_next/static/image/public/images/flags/flag_509.31544161907e847c751e2ac53a3714b0.svg","height":16,"width":24};